// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RequestEnvironmentMetadata
 */
export interface RequestEnvironmentMetadata {
  /**
   *
   * @type {string}
   * @memberof RequestEnvironmentMetadata
   */
  name?: string;
}

/**
 * Check if a given object implements the RequestEnvironmentMetadata interface.
 */
export function instanceOfRequestEnvironmentMetadata(
  value: object,
): value is RequestEnvironmentMetadata {
  return true;
}

export function RequestEnvironmentMetadataFromJSON(
  json: any,
): RequestEnvironmentMetadata {
  return RequestEnvironmentMetadataFromJSONTyped(json, false);
}

export function RequestEnvironmentMetadataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestEnvironmentMetadata {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'] == null ? undefined : json['name'],
  };
}

export function RequestEnvironmentMetadataToJSON(
  json: any,
): RequestEnvironmentMetadata {
  return RequestEnvironmentMetadataToJSONTyped(json, false);
}

export function RequestEnvironmentMetadataToJSONTyped(
  value?: RequestEnvironmentMetadata | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value['name'],
  };
}
